"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var NodeList = require("../generated/NodeList"); // https://dom.spec.whatwg.org/#mutationrecord


var MutationRecordImpl =
/*#__PURE__*/
function () {
  function MutationRecordImpl(globalObject, args, privateData) {
    _classCallCheck(this, MutationRecordImpl);

    this._globalObject = globalObject;
    this.type = privateData.type;
    this.target = privateData.target;
    this.previousSibling = privateData.previousSibling;
    this.nextSibling = privateData.nextSibling;
    this.attributeName = privateData.attributeName;
    this.attributeNamespace = privateData.attributeNamespace;
    this.oldValue = privateData.oldValue;
    this._addedNodes = privateData.addedNodes;
    this._removedNodes = privateData.removedNodes;
  }

  _createClass(MutationRecordImpl, [{
    key: "addedNodes",
    get: function get() {
      return NodeList.createImpl(this._globalObject, [], {
        nodes: this._addedNodes
      });
    }
  }, {
    key: "removedNodes",
    get: function get() {
      return NodeList.createImpl(this._globalObject, [], {
        nodes: this._removedNodes
      });
    }
  }]);

  return MutationRecordImpl;
}();

module.exports = {
  implementation: MutationRecordImpl
};